import React from "react";
import { GestionStaff } from "./GestionAdmins";

/**
 * Gestión de usuarios Comerciales (typeuser 4) desde SuperAdmin. Misma pantalla
 * que GestionAdmins (componente GestionStaff): alta con createStaffUser (el
 * servidor crea la cuenta y acá se manda el correo para que el comercial defina
 * su contraseña), edición con updateStaffUser y baja con removeStaffUser, que
 * archiva la ficha y no toca sus leads del CRM. No se vincula a ningún edificio.
 */
const GestionComerciales = ({ setSelected }) => <GestionStaff tipo="comercial" setSelected={setSelected} />;

export default GestionComerciales;
